import { createFileRoute } from "@tanstack/react-router";
import { BookingsTab } from "@/components/admin/BookingsTab";

export const Route = createFileRoute("/admin/bookings")({
  head: () => ({
    meta: [
      { title: "Bookings & redirects · Admin · INFLOW Marketing" },
      {
        name: "description",
        content:
          "Verify each intro and demo booking: tier, Schedule conversion status, and the email and UTMs carried to the thank-you page.",
      },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Bookings &amp; redirects</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Every booking, the tier it was routed to, whether the Schedule conversion
          fired, and the exact data handed to the thank-you page.
        </p>
      </div>
      <BookingsTab />
    </div>
  ),
});
